import { ReactNode, useEffect, useState } from "react";
import ChatMessages from "../../components/chatMessages";
import Calendar from "../../components/calendar";
import { Sidebar } from "@rio-cloud/rio-uikit";
import AssetTreeSidebar from "../../components/assetsTree";
import { useLocation, useSearchParams } from "react-router-dom";
import Indicators from "../../components/indicators";
import { OccurrenceWithTimeSpent } from "../../models/occurrence";

export type SidebarDemoKey = "showSidebarLeft";

export type SidebarProps = Partial<Record<SidebarDemoKey, boolean>> & {
  toggleSidebar?: (id: SidebarDemoKey) => void;
  assetIds: string[];
  groupIds: string[];
  setAssetIds: (assetIds: string[]) => void;
  setGroupIds: (groupIds: string[]) => void;
  setChassisList: (chassisList: string[]) => void;
  children: ReactNode;
  onSidebarStateChange?: (isOpen: boolean) => void;
  occurrenceList?: OccurrenceWithTimeSpent[];
  finalizedOccurrenceList?: OccurrenceWithTimeSpent[];
};

const LeftSidebar = (props: SidebarProps) => {
  const [showAssetTree, setShowAssetTree] = useState(
    () => !props.assetIds?.length && !props.groupIds?.length
  );

  const showAssetTreeFromRoutes = [
    "/control-tower/maintenance-monitoring",
    // "/control-tower/support"
  ];
  const location = useLocation();
  const currentRoute = location.pathname;
  const [searchParams, setSearchParams] = useSearchParams();

  const clearDeepLinkFilter = () => {
    const hasDeepLinkParam =
      searchParams.has("chassis") ||
      searchParams.has("asset") ||
      searchParams.has("periodic-review-modal-open");
    if (!hasDeepLinkParam) { return; }
    const next = new URLSearchParams(searchParams);
    next.delete("chassis");
    next.delete("asset");
    next.delete("periodic-review-modal-open");
    setSearchParams(next);
  };
  const enableAssetTree = showAssetTreeFromRoutes.some((route) =>
    currentRoute.includes(route)
  );

  useEffect(() => {
    if (enableAssetTree) props.onSidebarStateChange?.(showAssetTree);
  }, []);

  return (
    <div
      className="flex overflow-hidden"
      style={{ height: "calc(100vh - 50px)" }}
    >
      <div className="icons-col" style={{ minWidth: "50px" }}>
        {enableAssetTree ? (
          <span
            className="rioglyph rioglyph-truck"
            onClick={() => {
              const newState = !showAssetTree;
              setShowAssetTree(newState);
              props.onSidebarStateChange?.(newState);
            }}
          />
        ) : (
          <span />
        )}

        <div className="display-flex flex-column align-items-center icons-col__bottom">
          <Indicators persona={"TOWER"} setChassisList={props.setChassisList} assetIds={props.assetIds} occurrenceList={props.occurrenceList} finalizedOccurrenceList={props.finalizedOccurrenceList} />
          <ChatMessages />
          <Calendar />

          {enableAssetTree ? (
            <span
              className={`rioglyph rioglyph-chevron-${
                showAssetTree ? "left" : "right"
              }`}
              onClick={() => {
                const newState = !showAssetTree;
                setShowAssetTree(newState);
                props.onSidebarStateChange?.(newState);
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>

      {/* Asset Tree */}
      {enableAssetTree && <Sidebar closed={!showAssetTree} minWidth={300} resizable disableClose>
        <div className="w-full">
          <AssetTreeSidebar
            assetIds={props.assetIds}
            setAssetIds={props.setAssetIds}
            groupIds={props.groupIds}
            setGroupIds={props.setGroupIds}
            onUserInteraction={clearDeepLinkFilter}
            selectionLimit={
              currentRoute.includes("/control-tower/maintenance-monitoring")
                ? 10000
                : undefined
            }
          />
        </div>
      </Sidebar>}

      <div className="w-full">{props.children}</div>
    </div>
  );
};

export default LeftSidebar;
